import React, { useRef, useEffect, useState } from "react";
import "./App.css";
import { ReactComponent as PredatorLogo } from "./assets/images/symbol.svg";
import mainVideo from "./assets/videos/drone-main.mp4";
import overlayVideo from "./assets/videos/drone-overlay.mp4";

function App() {
  const contactRef = useRef(null);
  const mainVideoRef = useRef(null);
  const overlayVideoRef = useRef(null);

  const [showCinematicText, setShowCinematicText] = useState(false);
  const year = new Date().getFullYear();

  // 2. Synchronization Logic
  useEffect(() => {
    const main = mainVideoRef.current;
    const overlay = overlayVideoRef.current;

    if (!main || !overlay) return;

    // Helper to ensure both play together
    const syncPlay = () => {
      main.play().catch((e) => console.log("Main play error", e));
      overlay.play().catch((e) => console.log("Overlay play error", e));
    };

    // When the main video ends, force both to restart instantly
    const handleLoop = () => {
      main.currentTime = 0;
      overlay.currentTime = 0;
      syncPlay();
    };

    // Optional: If main pauses (buffering/user action), pause overlay
    const handlePause = () => {
      overlay.pause();
    };

    // Optional: If main plays, ensure overlay plays
    const handlePlay = () => {
      if (overlay.paused) overlay.play().catch(() => {});
    };

    // Attach listeners to the "Master" video
    main.addEventListener("ended", handleLoop);
    main.addEventListener("pause", handlePause);
    main.addEventListener("play", handlePlay);

    // Initial kick-off
    syncPlay();

    // Cleanup listeners on unmount
    return () => {
      main.removeEventListener("ended", handleLoop);
      main.removeEventListener("pause", handlePause);
      main.removeEventListener("play", handlePlay);
    };
  }, []);

  // 3. NEW: Trigger the text after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCinematicText(true);
    }, 3000); // 3000ms = 3 seconds delay before text starts

    return () => clearTimeout(timer);
  }, []);

  const handleLearnMoreClick = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="page">
      <header className="hero">
        <PredatorLogo className="hero-logo" />

        <div className="hero-heading">
          <h1 className="hero-title">Predator AI</h1>
          <h2 className="hero-subtitle">Foundational geospatial AI.</h2>
        </div>
      </header>

      <section className="hero-video-section">
        <div className="hero-video">
          {/* 3. Attach refs and REMOVE the 'loop' attribute.
               We handle looping in the useEffect to ensure they sync.
          */}
          <video
            ref={mainVideoRef}
            className="hero-video__bg"
            autoPlay
            muted
            playsInline
            // loop <--- Removed this
          >
            <source src={mainVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="hero-video__overlay">
            <video
              ref={overlayVideoRef}
              className="hero-video__overlay-video"
              autoPlay
              muted
              playsInline
              // loop <--- Removed this
            >
              <source src={overlayVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div
            className={`cinematic-text ${showCinematicText ? "active" : ""}`}
          >
            <h2 className="cine-line line-1">
              When GPS fails, WorldFrame™ doesn’t.
            </h2>
            <h2 className="cine-line line-2">Day or night. All weather.</h2>
            <h2 className="cine-line line-3">
              Because the mission doesn’t wait for daylight.
            </h2>
          </div>
        </div>
      </section>

      <main className="body-section">
        <p className="body-lead">
          Predator AI is building foundational geospatial models for the real
          world, solving GPS-denied navigation for robotic systems in contested
          environments.
        </p>
        <p className="body-copy">
          Our flagship system, WorldFrame™, uses the world’s largest thermal+RGB
          aerial dataset to deliver 24/7, all-weather, geo-rectified navigation
          for drones today and for every aerial vehicle tomorrow: from loitering
          munitions to artillery rounds.
        </p>
      </main>

      <section className="contact-section" ref={contactRef}>
        <h3 className="contact-title">Contact</h3>
        <p className="contact-text">
          Interested in learning more about WorldFrame™?
        </p>
        <a className="contact-email" href="mailto:info@predator.ai">
          info@predator.ai
        </a>
      </section>

      <footer className="footer">
        © {year} Predator AI. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
